export default "__VITE_ASSET__bzJgOMCj__ 430w";